var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.029,
    height: 22.005,
    viewBox: "0 0 22.029 22.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-edit-737749",
    d: "M78.536,66h-.688l-2.655,2.655,4.18,4.18,2.655-2.655v-.688ZM61.916,81.932,60,88l6.073-1.918L77.626,74.531l-4.18-4.18Z",
    transform: "translate(-59.998 -66)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.016a3739bbb29f06e1b222b4a410fb64.svg";
export { ForwardRef as ReactComponent };